export default {
  state: {
    defaultData: {},
  },

  getters: {
    getTranspotData(state) {
      return state.defaultData;
    },
  },

  mutations: {
    setTransportData(state, data) {
      const isNull = data === null;

      state.defaultData = {
        id: !isNull ? data.id : "",
        license_plate: !isNull ? data.license_plate : "",
        type: !isNull ? data.type : [],
        number_seats: !isNull ? data.number_seats : "",
        polyclinic_id: !isNull ? data.polyclinic.id : "",
      };
    },
  },

  actions: {
    changeTransportData(context, infos) {
      context.commit("setTransportData", infos);
    },
  },
};
